/// <amd-module name="Feed/Legacy/Helpers/CustomerIntelligenceHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";

import { CiConstants, FeedServiceInstanceId } from "Feed/Common/Constants/Constants";

export class CustomerIntelligenceHelper {
    public static publishEvent(
        pageContext: IVssPageContext,
        feature: string,
        // tslint:disable-next-line:no-any
        properties: { [key: string]: any } = {}
    ): void {
        // Tag events so we know they're coming from the UX
        properties.telemetrySource = "UX_2.0";

        const telemetryService = pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent(CiConstants.Area, feature, properties, FeedServiceInstanceId);
    }
}
